import config from "appConfig";
import { LayoutComponent } from "@jelly/lesson";

const component: LayoutComponent = {
  variant: "layout",
  data: {
    type: "table",
    options: {
      cols: 2,
      rows: 3,
      colsSize: [1, 3],
      rowsSize: [1, 4, 4],
      rowSpan: {
        "1:1": 2,
      },
      colSpan: {
        "0:0": 2,
      },
      gap: "17px",
      components: [
        [
          {
            variant: "blockContainer",
            data: {
              styles: {
                // alignItems: "flex-start",
              },
              block: {
                type: "text",
                options: {
                  data: "Data Acquisition and Generation: Powertrain",
                  styles: {
                    fontSize: "16px",
                    fontWeight: "700",
                  },
                  scrollbars: false,
                },
              },
            },
          },
        ],
        [
          {
            variant: "blockContainer",
            data: {
              styles: {
                alignItems: "flex-end",
              },
              block: {
                type: "image",
                options: {
                  src: `${config.ASSETS_URL}/03/case-02/principle/4-thumb-states.png`,
                  styles: {
                    maxHeight: "225px",
                  },
                },
              },
            },
          },
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "image",
                options: {
                  src: `${config.ASSETS_URL}/03/case-02/principle/4-states.png`,
                  viewType: "contain",
                  styles: {
                    maxWidth: "663px",
                  },
                },
              },
            },
          },
        ],
        [
          {
            variant: "blockContainer",
            data: {
              styles: {
                alignItems: "flex-start",
              },
              block: {
                type: "text",
                options: {
                  data:
                    "In the second step the engine is measured under operational conditions. The vehicle is running on a 4-wheel chassis dynameter.  For several load conditions the complete RPM range is measured in run-ups. The path contributions are calculated by combining the transfer functions with the operational data.",
                  styles: {
                    fontSize: "12px",
                    fontWeight: "600",
                  },
                  scrollbars: false,
                },
              },
            },
          },
        ],
      ],
    },
  },
};

export default component;
